module.exports = __webpack_public_path__ + "a04a22759bcb1e31098cef4199a4e1f6.png";